// @ts-check
import { values, forEach, partition, filter } from "lodash";

import {
  newGrouping,
  newGroupingOptions,
  getDailyRateByFlag,
  buildBudgetLookup,
} from "../../util";

const buildBySupply = ({
  rootGroup,
  groupLookup,
  hideHiddenTeams = false,
  showObjectives = false,
  groupTypes = {},
  columnCount = undefined,
  isBudgetEnabled,
  allocationProjectLookup,
}) => {
  let setGroupingBudget = null;
  if (isBudgetEnabled) {
    setGroupingBudget = buildBudgetLookup({
      groupLookup,
      rootGroup,
      allocationProjectLookup,
    });
  }

  let sourceGroupsYetToInsert = filter(
    values(groupLookup),
    (s) =>
      s.isSource && (s.parentIds?.includes(rootGroup.id) || rootGroup.isDemand)
  );
  let sourceGroupsToInsert = [];
  const rootGrouping = newGrouping({
    ...newGroupingOptions({
      group: rootGroup,
      groupType: groupTypes[rootGroup.type],
      parentGrouping: null,
      groupLookup,
    }),
    parentGrouping: null,
    rootGrouping: null,
    nestedLevel: 0,
    isRoot: true,
    canAddLineItem: false,
    canViewInTeamBuilder: true,
    canViewInDetails: false,
    showObjectives,
    columnCount,
    dailyRate: getDailyRateByFlag(
      rootGroup.isSource && isBudgetEnabled, // Only set for supply rootGroup
      rootGroup,
      null,
      groupLookup
    ),
  });
  rootGrouping.root = rootGrouping;
  const groupingsLookup = { [rootGrouping.id]: rootGrouping };
  // insert the groups in order from highest hierarchy level to lowest.
  for (let hierarchyLevel = 0; hierarchyLevel < 999; hierarchyLevel += 1) {
    [sourceGroupsToInsert, sourceGroupsYetToInsert] = partition(
      sourceGroupsYetToInsert,
      (s) => s.parentIds.length === hierarchyLevel
    );

    forEach(sourceGroupsToInsert, (sourceGroup) => {
      if (hideHiddenTeams && (sourceGroup.isHidden || sourceGroup.isDeleted)) {
        return;
      }

      let parentGrouping = groupingsLookup[sourceGroup.directParentId];
      if (!parentGrouping) {
        if (rootGroup.isDemand) {
          parentGrouping = rootGrouping;
        } else {
          // eslint-disable-next-line no-console
          console.warn(
            `ignoring group '${sourceGroup.id}'. Cannot find not parent '${sourceGroup.directParentId}'`
          );
          return;
        }
      }

      const grouping = newGrouping({
        ...newGroupingOptions({
          group: sourceGroup,
          groupType: groupTypes[sourceGroup.type],
          parentGrouping,
          isBudgetEnabled,
          groupLookup,
        }),
        parentGrouping,
        rootGrouping,
        nestedLevel: parentGrouping.nestedLevel + 1,
        memberCount: sourceGroup.memberCount,
        isSupply: true,
        isDemand: false,
        canAddLineItem: false,
        canViewInTeamBuilder: rootGroup.isSource,
        canViewInDetails: true,
        showObjectives,
        columnCount,
      });

      if (isBudgetEnabled) {
        setGroupingBudget(grouping, "isDemand");
      }
      parentGrouping.childGroupings.push(grouping);
      // TODO: perf improvement - insert child into correct position, instead of sorting everything.
      parentGrouping.childGroupings.sort((a, b) =>
        a.group.name.localeCompare(b.group.name)
      );
      groupingsLookup[grouping.id] = grouping;
    });

    if (sourceGroupsYetToInsert.length === 0) {
      break;
    }
  }

  return [rootGrouping];
};

export default buildBySupply;
